import Vue from "vue";

export const LeaveApplyEventBus = new Vue();
